import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiZap, FiArrowRight, FiDollarSign } = FiIcons;

/**
 * 額度指示器 - 顯示在對話頁面頂部
 * 🆕 新增:快速充值入口
 */
export default function QuotaIndicator({ character }) {
  const navigate = useNavigate();

  // 🔧 TODO: 從 API 取得真實額度資料
  const [quota, setQuota] = useState({
    messages: { used: 3, limit: 5, remaining: 2 },
    subscription: { tier: 'free', status: 'active' },
  });

  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    // 當剩餘額度 <= 1 時顯示警告
    if (quota.messages.remaining <= 1 && quota.messages.remaining > 0) {
      setShowWarning(true);
    } else {
      setShowWarning(false);
    }
  }, [quota]);

  const percentage = (quota.messages.used / quota.messages.limit) * 100;

  return (
    <>
      {/* 頂部狀態列 */}
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        className="fixed top-20 md:top-24 left-1/2 -translate-x-1/2 z-40 pointer-events-auto"
      >
        <div className="bg-[#0a0a0c]/80 border border-white/10 rounded-full px-4 py-2 backdrop-blur-md flex items-center space-x-3 shadow-lg">
          <SafeIcon icon={FiZap} className="text-amber-400 text-sm" />
          <div className="flex items-center space-x-2">
            <span className="text-gray-400 text-xs tracking-wider">今夜剩餘:</span>
            <span
              className={`text-sm font-medium tracking-wider ${
                quota.messages.remaining <= 1 ? 'text-red-400' : 'text-amber-400'
              }`}
            >
              {quota.messages.remaining}/{quota.messages.limit}
            </span>
          </div>

          {/* 進度條 */}
          <div className="w-16 h-1.5 bg-white/10 rounded-full overflow-hidden">
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: `${percentage}%` }}
              className={`h-full ${percentage >= 80 ? 'bg-red-400' : 'bg-amber-400'}`}
            />
          </div>

          {/* 🆕 快速充值按鈕 */}
          <button
            onClick={() => navigate('/pricing')}
            className="ml-2 p-1.5 bg-amber-500/10 border border-amber-500/30 rounded-full hover:bg-amber-500/20 transition-all group"
            title="充值"
          >
            <SafeIcon icon={FiDollarSign} className="text-amber-400 text-sm group-hover:scale-110 transition-transform" />
          </button>
        </div>
      </motion.div>

      {/* 警告提示 (剩餘 1 則訊息時) */}
      <AnimatePresence>
        {showWarning && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            className="fixed bottom-32 md:bottom-40 left-1/2 -translate-x-1/2 z-40 pointer-events-auto max-w-md w-full px-6"
          >
            <div className="bg-amber-500/10 border border-amber-500/30 rounded-2xl p-5 backdrop-blur-md shadow-[0_0_30px_rgba(245,158,11,0.2)]">
              <div className="flex items-start space-x-4">
                <SafeIcon icon={FiZap} className="text-amber-400 text-xl mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <p className="text-amber-300 text-sm tracking-wide mb-3 leading-relaxed">
                    今晚最後一杯了。<br />
                    想繼續聊天嗎?
                  </p>
                  <div className="flex items-center space-x-3">
                    <button
                      onClick={() => setShowWarning(false)}
                      className="px-4 py-2 bg-white/5 border border-white/10 text-gray-400 rounded-lg text-xs tracking-wider hover:bg-white/10 transition-all"
                    >
                      明天再來
                    </button>
                    <button
                      onClick={() => navigate('/pricing')}
                      className="px-4 py-2 bg-amber-500 text-black rounded-lg text-xs tracking-wider hover:bg-amber-400 transition-all flex items-center space-x-2"
                    >
                      <span>查看方案</span>
                      <SafeIcon icon={FiArrowRight} className="text-sm" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}